import React from 'react'
import { Main } from '../AcademicCurriculum/AcademicCurriculum.element'
import { Directortext } from '../Codeofconduct/Code.element'
import { Directorbackground, Div } from './Annualfunction.element'


function Annualfunction() {
    return (
        <Main>
                <Directorbackground>
                <Directortext>
                    <h1>Annual Function</h1>
                    <p>The New Era Public School| <span>Annual Function</span> </p>
                </Directortext>
             


            </Directorbackground>
            <h1 style={{textAlign:'center',padding:'20px'}}>Annual Function</h1> 

            <Div style={{display:'flex',flexWrap:'wrap'}}>

                        <img style={{height:'300px',width:'300px'}} src='\website data for 2025-26\annual function\annualfunction1.JPG' alt="" />
                        <img style={{height:'300px',width:'300px'}} src='\website data for 2025-26\annual function\annualfunction2.JPG' alt="" />
                        <img style={{height:'300px',width:'300px'}} src='\website data for 2025-26\annual function\annualfunction3.JPG' alt="" />
                        <img style={{height:'300px',width:'300px'}} src='\website data for 2025-26\annual function\annualfunction4.JPG' alt="" />
                        <img style={{height:'300px',width:'300px'}} src='\website data for 2025-26\annual function\annualfunction5.JPG' alt="" />
                        <img style={{height:'300px',width:'300px'}} src='\website data for 2025-26\annual function\annualfunction6.JPG' alt="" />
                        <img style={{height:'300px',width:'300px'}} src='\website data for 2025-26\annual function\annualfunction7.JPG' alt="" />
                        <img style={{height:'300px',width:'300px'}} src='\website data for 2025-26\annual function\annualfunction8.JPG' alt="" />
                        <img style={{height:'300px',width:'300px'}} src='\website data for 2025-26\annual function\annualfunction9.JPG' alt="" />
                        <img style={{height:'300px',width:'300px'}} src='\website data for 2025-26\annual function\annualfunction10.JPG' alt="" />
                </Div>


        </Main>
    )
}

export default Annualfunction
